//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'



//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const selectore = (state) => state.oneway_teacher_video;
//  -- Examples array selector --------



export const useOneWayTeacherVideo = () =>{
    const selectedData = useSelector(selectore, shallowEqual)
    return selectedData;
}